/**
 * Models a Monero version.
 */
export default class MoneroVersion {
    constructor(number, isRelease) {
        this.number = number;
        this.isRelease = isRelease;
    }
    getNumber() {
        return this.number;
    }
    setNumber(number) {
        this.number = number;
        return this;
    }
    getIsRelease() {
        return this.isRelease;
    }
    setIsRelease(isRelease) {
        this.isRelease = isRelease;
        return this;
    }
    copy() {
        return new MoneroVersion(this.number, this.isRelease);
    }
    toJson() {
        return Object.assign({}, this);
    }
}
